import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';
import { environment as env } from "src/environments/environment";

/**
* @author Lucas P. Soares
* @contact lucas.lps@ecxus.com.br
* @date 10/08/2022
* @version 1.0.0
* @description <p> Classe Service para trabalhar com criptografias </p>
*
* @revisions_history
* - Version   -   Author    -    Description
*  1.0.0       Lucas Peres   Criação da classe
*/
@Injectable({
    providedIn: "root"
})
export class CryptoService {

    constructor() {}

    encryptAES(text: string): string {
        return CryptoJS.AES.encrypt(text, env.cryptoKey).toString();
    }

    decryptAES(text: string): string {
        return CryptoJS.AES.decrypt(text, env.cryptoKey).toString(CryptoJS.enc.Utf8);
    }

    encryptMd5(text: string): string {
        //return CryptoJS.MD5(text).toString();
        return this.hashCode(text);
    }

    hashCode(str: string): string {
        var hash = 0, i = 0, len = str.length;
        while ( i < len ) {
            hash  = ((hash << 5) - hash + str.charCodeAt(i++)) << 0;
        }
        return hash as any;
    }

    encryptSha256(text: string): string {
        return CryptoJS.SHA256(text).toString();
    }
    
    encodeBase64(text: string): string {
        const encodedWord = CryptoJS.enc.Utf8.parse(text); // Transforma em Array object
        const encoded = CryptoJS.enc.Base64.stringify(encodedWord); // Encode Base64
        return encoded;
    }

    decodeBase64(text: string): string {
        const encodedWord = CryptoJS.enc.Base64.parse(text);
        const decoded = CryptoJS.enc.Utf8.stringify(encodedWord);
        return decoded;
    }

}